export default {
  // RejectPhone
  rejectNumber: '수신거부 번호',
  explanation: '설명',
  registrationDate: '등록일시',
  state: '상태',
};
